import React, { useState, useEffect } from "react";
import { Col, FormGroup, Input, Label, Row, Card } from "reactstrap";
import { LabelWithToolTip } from "../../../../atoms/LabelWithToolTip";
import Select from "react-select";
import LockFieldsButton from "../../../../molecules/LockFieldsButton";

const IbanForm = (props) => {

  return (
    <>
      {/* Purpose */}
      <FormGroup>
        <LabelWithToolTip
          id="labelPurpose"
          labelText="Purpose *"
          tooltipText="How this account will be used: Payroll = salary payments; Expenditure = expenses and reimbursements; All = both payroll and expenditure."
        />
        <Select
          value={props.purpose ? props.purposeOption.find((item) => item.value === props.purpose) : null}
          onChange={(e) => props.setPurpose(e?.value)}
          options={props.purposeOption}
          placeholder="Select..."
        />
      </FormGroup>

      {/* Currency and Keep This Only fields */}
      <Row>
        <Col sm="12" md="6">
          <FormGroup>
            <LabelWithToolTip
              id="labelCurrency"
              labelText="Currency *"
              tooltipText="Select the currency for this bank account"
            />
            <select
              {...props.register("currencyId")}
              className="form-control"
              value={
                props.sortedCurrencyList?.find((c) => c.currencyCode === props.currency)?.id || ""
              }
              onChange={props.onCurrencyChanged}
            >
              {(props.sortedCurrencyList || []).map((currency, index) => (
                <option key={currency.id} value={currency.id}>
                  {currency.currencyCode}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
      </Row>


      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelBeneficiaryName"
              labelText="Beneficiary Name *"
              tooltipText="Name of the account holder as it appears on the bank account. 
              Only alphanumeric characters, spaces, parentheses, commas and periods. Ampersands (&) are not permitted."
            />
            <input
              {...props.register("beneficiaryBankAccountName")}
              maxLength="100"
              type="text"
              className="form-control"
              value={props.beneficiaryName || ""}
              onChange={props.onBeneficiaryNameChange}
            />
          </FormGroup>
        </Col>
      </Row>

      {/* IBAN Account Number */}
      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="labelIbanAccountNumber"
              labelText="IBAN Account Number *"
              tooltipText="International Bank Account Number in valid IBAN format (e.g., GB33BUKB20201555555555). 
              Length varies by country (15-34 characters). Only alphanumeric characters allowed."
            />
            <input
              type="text"
              {...props.register("bankAccountNumber")}
              className="form-control"
              onChange={props.resetMetadata}
            />
          </FormGroup>
        </Col>
      </Row>

      {/* Auto-filled fields - only visible if bank selected from MyHR OR after manual IBAN validation */}
      {(props.selectedBankFromMyHR || props.isIbanValidated) && (
        <>
          {/* Lock/Unlock Button */}
          <LockFieldsButton allowEdit={props.allowEdit} setAllowEdit={props.setAllowEdit} />

          {/* BIC/SWIFT */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>BIC SWIFT</Label>
                <input
                  type="input"
                  {...props.register("bic")}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                  onChange={props.resetMetadata}
                />
              </FormGroup>
            </Col>
          </Row>


          {/* Bank Name */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Bank</Label>
                <input
                  type="input"
                  {...props.register("bankName", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>


          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Branch</Label>
                <input
                  type="input"
                  {...props.register("branch", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                />
              </FormGroup>
            </Col>
          </Row>


          {/* Address Fields */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>City</Label>
                <input
                  type="input"
                  {...props.register("bankCity", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Zip Code</Label>
                <input
                  type="input"
                  {...props.register("bankZip", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Country</Label>
                <input
                  type="input"
                  {...props.register("bankCountry", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* ISO Country Code Field */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Country Code</Label>
                <input
                  type="input"
                  className="form-control"
                  value={props.isoCountryCode || ""}
                  onChange={(e) => props.onCountryCodeChange && props.onCountryCodeChange(e.target.value)}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isIbanValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

        </>
      )}
    </>
  );
};


export default IbanForm;
